export const getReportingAggregate = (data: any) => {
  let agg: any = {
    exp: {
      budget_amount: 0.0,
      budget_percentage: 0.0,
      actual_amount: 0.0,
      actual_percentage: 0.0,
      variance_amount: 0.0,
      variance_percentage: 0.0,
      ytd_budget_amount: 0.0,
      ytd_budget_percentage: 0.0,
      ytd_actual_amount: 0.0,
      ytd_actual_percentage: 0.0,
      ytd_variance_amount: 0.0,
      ytd_variance_percentage: 0.0,
      py_actual_amount: 0.0,
      difference: 0.0,
    },
    ebitda: {},
  }
  const revenue = data?.[0]
  data?.slice(1).forEach((item: any) => {
    Object.keys(item).forEach((field: string) => {
      if (agg?.exp[field] !== undefined) {
        agg.exp[field] += item[field] ? parseFloat(item[field]) : 0
      }
    })
  })

  Object.keys(agg?.exp)?.forEach((field) => {
    if (field.includes("amount")) {
      agg["ebitda"][field] = revenue[field] - agg?.exp[field]
    } else {
      agg["ebitda"][field] = 100 - agg?.exp[field]
    }
  })
  return {
    agg,
    data,
  }
}

export const transformReportingDetailData = (payload: any) => {
  if (!payload) {
    return []
  }

  let data: any = []
  let agg: any = []
  payload.forEach((account: any) => {
    account["account_class_list"].forEach((accountClass: any) => {
      accountClass["account_sub_class_list"].forEach(
        (subClass: any, index: number) => {
          let rowEntry: any = {}
          rowEntry["account"] = account["account"]
          rowEntry["account-class"] =
            index === 0 && accountClass["account_class"]
          rowEntry["current-account-class"] = accountClass["account_class"]
          rowEntry["account-sub-class"] = subClass["account_sub_class"]
          let ttmValue = 0.0

          Object.keys(subClass["year_list"]).forEach((year: string) => {
            rowEntry[year] = subClass["year_list"][year]
          })

          // let yearList = subClass.year_list
          // Object.keys(yearList).forEach((year: string) => {
          //   const monthList = yearList?.[year]?.month_list
          //   Object.keys(monthList).forEach((month) => {
          //     const amount = parseFloat(
          //       monthList[month]?.transaction_amount || "0",
          //     )
          //     rowEntry[`${month}-${year.slice(2)}`] = amount
          //     ttmValue += amount
          //   })
          // })

          rowEntry["TTM"] = subClass["ttm"]
          data.push(rowEntry)
        },
      )
    })
  })

  data?.forEach((item: any) => {
    Object.keys(item).forEach((key: string) => {
      if (!isNaN(Number(item[key]))) {
        const numericValue = Number(item[key])
        if (agg[key]) {
          agg[key] += numericValue
        } else {
          agg[key] = numericValue
        }
      }
    })
  })

  return { data, agg }
}
